import React, { createContext, useState, useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import { TopNavColumn } from './top-nav-column'
import { TopNavRow } from './top-nav-row'
import { TopNavMenu } from './top-nav-menu'
import { TopNavMenuItem } from './top-nav-menu-item'
import { TopNavItem } from './top-nav-item'
import { TopNavItemsContainer } from './top-nav-items-container'
import { TopNavItemContainer } from './top-nav-item-container'
import { TopNavContainer } from './top-nav-container'
import { TopNavToggle } from './top-nav-toggle'
import { useApplicationContext } from '../../../context/ApplicationContext'
import BannerModule from '../../banner'

export const TopNavContext = createContext(null)

const TopNav = (props) => {
  const ref = useRef()
  const [height, setHeight] = useState(0)
  const { children, ...rest } = props
  const [contextState] = useState('')

  const context = useApplicationContext() || {}
  useEffect(() => {
    setHeight(ref?.current?.clientHeight)
  }, [ref?.current?.clientHeight])

  return (
    <TopNavContext.Provider value={contextState}>
      <header ref={ref} className="dev_dash__top-nav" {...rest}>
        {children}
      </header>
      {context?.banner?.isActive && (
        <BannerModule bannerInfo={context.banner} offset={height} />
      )}
    </TopNavContext.Provider>
  )
}

TopNav.Container = TopNavContainer
TopNav.Column = TopNavColumn
TopNav.Row = TopNavRow
TopNav.ItemsContainer = TopNavItemsContainer
TopNav.ItemContainer = TopNavItemContainer
TopNav.Item = TopNavItem
TopNav.Menu = TopNavMenu
TopNav.MenuItem = TopNavMenuItem
TopNav.TopNavToggle = TopNavToggle
export { TopNav }

TopNav.displayName = 'TopNav'

TopNav.propTypes = {
  as: PropTypes.any,
  children: PropTypes.any.isRequired,
  isLogged: PropTypes.bool,
}
